import React, { useState, createContext, useReducer, useEffect } from 'react'
import levelsInfo from '../content/level-menu'
// import { useLocalStorage, writeStorage } from '@rehooks/local-storage'

import { SCORM } from 'pipwerks-scorm-api-wrapper'
import { bindScormToWindow } from '../utils/bindScormToWindow'

// Create initial context based on information in Level Menu.
// This will keep track of a users progress at any given time.
// TODO: Use cookies or something to save progress if user closes browser.
const courseStore = createContext(levelsInfo)
const { Provider } = courseStore

const CourseStateProvider = ({ children, history }) => {
  const [scoInitialized, setScoInitialized] = useState(false)
  const getSuspendData = (moduleInfo) => {
    console.log('gotsuspend')
    window.addEventListener('beforeunload', () => {
      SCORM.save()
      SCORM.quit()
    })
    window.addEventListener('onbeforeunload', () => {
      SCORM.save()
      SCORM.quit()
    })
    let susp
    if (!scoInitialized) {
      SCORM.init()
      console.log('was scorm found?', SCORM.API.isFound)
      if (!SCORM.API.isFound) {
        bindScormToWindow()
        SCORM.init()
      } else if (SCORM.API.isFound && !SCORM.connection.isActive) {
        window.close()
      }
      window.SCORM = SCORM
      setScoInitialized(true)
      if (SCORM.get('cmi.core.lesson_status') !== 'completed') {
        SCORM.set('cmi.core.lesson_status', 'incomplete')
        SCORM.save()
      }
      susp = SCORM.get('cmi.suspend_data')
      console.log('state during first launch is: ', susp)
      if (susp === 'undefined' || susp === '') {
        susp = moduleInfo
        SCORM.set('cmi.suspend_data', JSON.stringify(susp))
        SCORM.save()
      } else {
        susp = JSON.parse(susp)
      }
      const defaultLaunchData = {
        courseMode: 'User'
      }
      const launchData = SCORM.get('cmi.launch_data') // Either Guest, User or Kompetansepluss
      if (launchData) { susp.launchData = JSON.parse(launchData) } else { susp.launchData = defaultLaunchData }

      // Handle course differently depending on mode set in launch data
      if (susp.launchData.courseMode === 'Guest') {
        susp.allowSkip = true
        susp.levels = susp.levels.filter(level => level.id !== 'l-9') // Remove kompetansepluss from normal user
      } else if (susp.launchData.courseMode === 'User') {
        susp.allowSkip = false
        susp.levels = susp.levels.filter(level => level.id !== 'l-9') // Remove kompetansepluss from normal user
      } else if (susp.launchData.courseMode === 'Kompetansepluss') {
        // In case user already completed course as a normal user, but upgrades to kompetansepluss.
        if (susp.levels.findIndex(level => level.id === 'l-9') === -1) {
          susp.levels.push(levelsInfo.levels.find(level => level.id === 'l-9'))
          if (susp.courseCompleted) {
            susp.courseCompleted = false
            SCORM.set('cmi.core.lesson_status', 'incomplete')
          }
        }
        // La brukeren hoppe over oppgaver hvis hen allerede har fullført kurset og kikker innom
        susp.allowSkip = susp.courseCompleted
      }
    }
    return susp
  }

  // const [localCourseState] = useLocalStorage('courseState', levelsInfo)

  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      // Action to be triggered when user completes a given module.
      case 'completed-level': {
        console.log(action)
        const level = state.levels.find(level => level.id === action.levelID)
        const completedAllTasks = level.tasks.filter(task => task.completed).length === level.tasks.length
        if (!level.completed && completedAllTasks) {
          level.completed = true
          state.completedLevels = state.levels.filter(l => l.completed).length
          state.courseCompleted = state.completedLevels === state.levels.length
          // Set course to completed, if either kompetansepluss and all 9 modules are completed.
          // Else it's as a guest/logged in user. Set it as complete on 8 modules completed
          if ((state.launchData.courseMode === 'Kompetansepluss' && state.completedLevels === 9) ||
          (state.launchData.courseMode !== 'Kompetansepluss' && state.completedLevels === 8)) {
            if (SCORM.get('cmi.core.lesson_status') !== 'completed') {
              SCORM.set('cmi.core.lesson_status', 'completed')
              SCORM.save()
            }
          }
        }
        level.lastpage = 'page-1'
        // If already completed, simply set lastpage back to 1, to enable users to revisit modules.
        // @mazoth
        // Need to use spread operator to ensure that mutations inside of an Array are detected and
        // Triggers a rerender
        return { ...state }
      }
      case 'next-module-page': {
        const currLevel = state.levels.find(m => m.id === action.levelID)
        currLevel.lastpage = action.pageID
        return { ...state }
      }
      // Dispatch action to handle enabling/disabling kompetansepluss until a LMS tells us to or not
      case 'show-kompetansepluss': {
        state.showKompetansePluss = true
        return { ...state }
      }
      case 'hide-kompetansepluss': {
        state.showKompetansePluss = false
        return { ...state }
      }
      case 'change-language': {
        return { ...state, language: action.language }
      }
      case 'toggle-subtitles': {
        return { ...state, showSub: action.show }
      }
      // Simple clearing of current state
      case 'clear-storage': {
        return levelsInfo
      }
      // Action for showing and hiding the skip button
      case 'toggle-skip':
        state.allowSkip = action.toggle
        return { ...state }
      // Need to keep track of completed tasks. Update the current task to completed, if called
      case 'completed-task': {
        const level = state.levels.find(level => level.id === action.levelID)
        const currentTask = level.tasks.find(task => task.id === action.pageID)
        currentTask.completed = true
        return { ...state }
      }
      default: {
        throw new Error('Action type not found')
      }
    }
  }, levelsInfo, getSuspendData)

  useEffect(() => {
    if (scoInitialized) {
      SCORM.set('cmi.suspend_data', JSON.stringify(state))
      SCORM.save()
    }
    return () => {
      SCORM.set('cmi.suspend_data', JSON.stringify(state))
      SCORM.save()
      // If component unmounted, quit the connection, and try again when component loaded again.
    }
  }, [state, scoInitialized])

  /*
  useEffect(() => {
    writeStorage('courseState', state)
  }, [state])
 */
  // When course state changes, update suspsend data with the new data
  return <Provider value={{ state, dispatch }}>{children}</Provider>
}

export { courseStore, CourseStateProvider }
